var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMarkerCharge(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 66,
    viewBox: "0 0 46 66",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.286133 23.1086C0.286133 10.5035 10.481 0.308594 23.0861 0.308594C35.6913 0.308594 45.8861 10.5035 45.8861 23.1086C45.8861 28.776 44.2576 34.0852 41.261 38.8732C39.6715 41.4665 37.8242 43.8622 35.9796 46.2544C34.2331 48.5193 32.4891 50.781 30.9684 53.2046C29.4376 55.6475 28.3627 57.9275 27.1576 60.5657C27.018 60.8728 26.8822 61.2181 26.7402 61.5796C26.0533 63.327 25.2182 65.4515 23.0861 65.4515C20.9761 65.4515 20.1364 63.3707 19.4355 61.6339C19.2817 61.2527 19.1345 60.8881 18.9821 60.5657C17.8096 57.9275 16.7021 55.6475 15.1713 53.2046C13.6247 50.7236 11.847 48.4179 10.0707 46.1141C8.25586 43.7601 6.4425 41.4082 4.8787 38.8732C1.9147 34.0852 0.286133 28.776 0.286133 23.1086ZM27.4829 32.0968L29.0464 36.1356H35.3978L25.8218 13.3031H19.6984L9.89437 36.1356H16.0178L17.6138 32.0968H27.4829ZM25.7241 27.5368H19.4052L22.5972 19.3939L25.7241 27.5368Z",
    fill: "#A7B4CA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarkerCharge);
export default __webpack_public_path__ + "static/media/marker-charge.78d5a8adb646c5d609f1ced7ada7be0f.svg";
export { ForwardRef as ReactComponent };